var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { BaseEvent } from './base-event';
/**
 * Arguments for the `noteClick` event.
 */
var NoteClickEvent = /** @class */ (function (_super) {
    __extends(NoteClickEvent, _super);
    /**
     * @hidden
     */
    function NoteClickEvent(e, target) {
        var _this = _super.call(this, target) || this;
        _this.category = e.category;
        _this.dataItem = e.dataItem;
        _this.series = e.series;
        _this.value = e.value;
        _this.visual = e.visual;
        return _this;
    }
    return NoteClickEvent;
}(BaseEvent));
export { NoteClickEvent };
//# sourceMappingURL=note-click-event.js.map